import { format } from 'owa-localize';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import updateEmojiMru from '../services/updateEmojiMru';
import { EMOJI_MAX_MRU } from '../utils/getEmojiMru';
import { action } from 'satcheljs/lib/legacy';

/**
 * Add a specific emoji to user options Emoji MRU list including updating to server
 */
export default action('addEmojiToMru')(function addEmojiToMru(emoji: string) {
    if (!emoji) {
        return;
    }

    // Prepare new emoji list
    let emojiCss = format('csimg image-emoji_{0}-png', emoji);
    let updatedEmojis = [emojiCss];

    // Merge with existing emoji list
    let userOptions = getUserConfiguration().UserOptions;
    let currentEmojis = userOptions.MruEmojis;
    if (currentEmojis && currentEmojis.length > 0) {
        for (let existingEmoji of currentEmojis) {
            if (existingEmoji != emojiCss) {
                updatedEmojis.push(existingEmoji);
                if (updatedEmojis.length >= EMOJI_MAX_MRU) {
                    break;
                }
            }
        }
    }

    // Update to UserOptions
    userOptions.MruEmojis = updatedEmojis;

    // Save to server
    updateEmojiMru(updatedEmojis);
});
